import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center'
  } satisfies SxProps<Theme>,
  description: {
    marginLeft: 1,
    fontStyle: 'italic',
    fontWeight: 'normal'
  } satisfies SxProps<Theme>
}
